import { Api } from "@/api";
import { ShippingOrder } from "@/types/ShippingOrder";

type CreateShippingOrderRequest = {
  external_order_identifier: string;
  ordered_at: string; // ISO 8601 format
  recipients: {
    first_name?: string;
    email?: string;
    phone_number?: string;
    address: string;
    postal_code: string;
    city?: string;
    state?: string;
    country?: string;
    line_items: {
      item_name: string;
      quantity: string;
      weight_in_ounces: string;
    }[];
  }[];
};

export const ShippingApi = {
  getOrders() {
    return Api.get<{ orders: ShippingOrder[] }>(`/api/shippings/orders`).then(
      res => res.data
    );
  },
  // getOrder(id) was removed 2026-08-04 — its only caller was the vestigial
  // DashboardOrders lookup deleted the same day (see that file's comment).
  createOrder(data: CreateShippingOrderRequest) {
    return Api.post(`/api/shippings/orders`, data).then(res => res.data);
  },
  async calculateShipping(
    dimensions: { width: number; height: number },
    zipcode: string
  ) {
    try {
      const response = await Api.post<{
        basePrice: number;
        totalPrice: number;
        error?: string;
      }>("/api/shippings/calculate-price", { dimensions, zipcode });

      if (response.data.error) {
        console.warn(
          "❌ Shipping calculation failed:",
          JSON.stringify(response.data.error)
        );
        return null;
      }

      return response.data.basePrice; // or response.data.totalPrice - they're the same
    } catch (error) {
      console.error("❌ SHIPPING API - Request failed completely:", {
        error,
        errorMessage: error instanceof Error ? error.message : "Unknown error",
        errorStack: error instanceof Error ? error.stack : undefined,
      });
      return null;
    }
  },
};
